import type { FetchResult } from '@apollo/client'
import { useMutation } from '@truepill/tpos-react-router'
import { UNCANCEL_OTC } from 'gql'
import useErrorToast from './toast/useErrorToast'
import useSuccessToast from './toast/useSuccessToast'

export default function useUncancelOtc(): (orderId: string, otcProductId: string) => Promise<FetchResult<any>> {
  const showErrorToast = useErrorToast()
  const showSuccessToast = useSuccessToast()
  const [mutate] = useMutation<{ orderId: string; otcProductId: string }>(UNCANCEL_OTC, {
    onCompleted: () => {
      showSuccessToast('Otc un-cancelled successfully!')
    },
    onError: error => {
      console.error(`Failed to un-cancel otc:`, error)
      showErrorToast(`Failed to un-cancel otc: ${error}`)
    },
  })

  return (orderId: string, otcProductId: string) => mutate({ variables: { orderId, otcProductId } })
}
